var _rect, _path, _path2, _rect2, _path3, _circle, _path4, _ellipse, _ellipse2, _rect3, _circle2, _path5, _path6, _rect4, _path7, _path8, _rect5, _path9, _path10, _path11, _path12, _circle3, _path13, _ellipse3, _ellipse4, _rect6, _path14, _rect7, _circle4, _ellipse5, _ellipse6, _path15, _path16, _path17, _path18, _path19, _rect8, _rect9, _circle5, _circle6, _rect10, _rect11, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgIntroduction4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 346,
    viewBox: "0 0 508 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 508,
    height: 346,
    rx: 16,
    fill: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.487 129.457C142.624 128.055 151.368 133.701 153.852 142.605L157.061 154.116C160.448 166.26 150.804 178.101 138.227 177.245L62.3577 172.08C53.6052 171.484 46.9986 163.896 47.6128 155.144C48.1317 147.75 53.7026 141.701 61.0292 140.577L133.487 129.457Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.633 155.571C105.205 138.791 120.359 128 137.335 128H169.644C193.003 128 211.393 147.932 209.515 171.215L200.644 281.209C200.562 282.227 199.725 283.02 198.704 283.047L125.908 284.963C125.064 284.985 124.307 284.502 124.009 283.712C120.648 274.821 101.162 221.977 100.371 190C100.053 177.126 101.136 165.335 102.633 155.571Z",
    fill: "#606060"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 143.471,
    width: 36.5305,
    height: 110.223,
    rx: 18.2652,
    transform: "rotate(-21.6381 166 143.471)",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142 109H174.414L173 146.856H144.5L142 109Z",
    fill: "#F0AAA2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.4369,
    cy: 36.4369,
    r: 36.4369,
    transform: "matrix(-1 0 0 1 185.123 48.5781)",
    fill: "#F0AAA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.396 101L129.735 106.132L136.051 101.892",
    stroke: "#D96F62",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.76308,
    cy: 4.70154,
    rx: 1.76308,
    ry: 4.70154,
    transform: "matrix(-1 0 0 1 145.159 83.8398)",
    fill: "#2D2D2D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.76308,
    cy: 4.70154,
    rx: 1.76308,
    ry: 4.70154,
    transform: "matrix(-1 0 0 1 122.827 79.1387)",
    fill: "#2D2D2D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 119.237,
    y: 73.2617,
    width: 9.40308,
    height: 2.35077,
    rx: 1,
    transform: "rotate(28.1385 119.237 73.2617)",
    fill: "#2D2D2D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.22769,
    cy: 8.22769,
    r: 8.22769,
    transform: "matrix(-1 0 0 1 191 79.1387)",
    fill: "#F0AAA2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.852 69.5872C144.505 62.0226 138.273 56.9796 135.325 55.4036C116.797 57.9252 113.06 75.6284 112.919 84.1648C110.954 79.3056 106.775 67.3809 110.48 58.5555C115.112 47.5237 126.061 43.9779 140.378 39.644C154.695 35.3101 157.643 40.826 161.012 41.614C164.38 42.4019 172.802 38.856 182.908 49.4938C190.993 58.0039 189.979 74.0525 187.874 81.013C187.733 80.3563 185.123 78.5508 179.961 79.437C173.723 80.5079 173.223 87.7108 161.012 88.4988C148.8 89.2867 147.537 79.043 145.852 69.5872Z",
    fill: "#2D2D2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M407.202 168.805C402.515 160.45 392.059 157.298 383.536 161.672C374.262 166.431 371.039 178.102 376.557 186.946L419.683 256.064C424.396 263.619 434.393 265.834 441.857 260.977C448.882 256.406 451.156 247.169 447.056 239.859L407.202 168.805Z",
    fill: "#606060"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 372.244,
    y: 234.689,
    width: 89.2899,
    height: 58.9129,
    transform: "rotate(-7.03004 372.244 234.689)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6046 86.5372L62.4997 125.499L80.4998 139.999C88.8899 120.708 104.668 81.6108 105.877 78.6964C107.388 75.0535 105.062 69.4309 104.343 68.3565C103.768 67.4969 104.211 66.4904 104.505 66.0946C106.193 64.2073 110.22 59.6153 112.818 56.3456C116.066 52.2586 115.566 49.7221 115.178 48.785C114.868 48.0353 114.478 47.9771 114.322 48.0417C109.079 51.948 98.2841 59.9432 97.0497 60.6733C95.8153 61.4034 95.232 62.2483 95.0946 62.5795L83.6046 86.5372Z",
    fill: "#F0AAA2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M402.669 206.648C409.924 181.513 391.496 156.294 365.345 155.57L351.011 155.173C328.003 154.535 309.206 173.399 309.924 196.405L312.94 293.062C312.973 294.142 313.858 295 314.939 295H395.984C397.27 295 398.222 293.802 397.932 292.549L391.347 264.131C389.808 257.487 389.993 250.561 391.884 244.008L402.669 206.648Z",
    fill: "#606060"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 36.5305,
    height: 110.223,
    rx: 18.2652,
    transform: "matrix(-0.831837 -0.555019 -0.555019 0.831837 360.082 169.254)",
    fill: "#606060"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M377.069 217.498C385.5 188.998 379.267 165.412 377.621 153.574C383.16 155.014 389.575 159.726 390.452 162.999C391.154 165.618 389.518 169.486 388.613 171.093C389.828 171.352 392.325 172.554 392.6 175.287C392.943 178.703 391.374 192.073 388.613 200.998C386.404 208.138 380.852 222.748 377.069 229.998C378.154 225.498 379.621 222.498 377.069 217.498Z",
    fill: "#4C4C4C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M381.691 136.072L349.377 133.534L347.821 171.384L375 179.5L381.691 136.072Z",
    fill: "#F0AAA2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M378.1 220.998C380.5 209.398 385 170.998 378.5 155.498L375 177.5L347.5 156.498C348.667 159.831 351.8 177.098 358.6 191.498C365.4 205.898 373.5 213.998 378.1 220.998Z",
    fill: "#EEEEEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M379.5 221.999C370.218 206.554 355.661 168.822 348.203 152.172C346.571 152.226 345.209 153.441 344.732 154.042C341.189 158.318 334.186 167.103 334.511 168.028C334.836 168.953 336.005 169.668 336.548 169.91C338.588 170.492 342.83 172.119 343.48 173.969C344.293 176.282 340.412 178.945 340.613 181.473C340.813 184.001 341.832 184.942 354.056 198.184C363.834 208.778 374.2 218.666 379.5 221.999Z",
    fill: "#4C4C4C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 371.614,
    cy: 116.224,
    r: 35,
    transform: "rotate(4.492 371.614 116.224)",
    fill: "#F0AAA2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M385.788 133.673C384.614 133.776 381.168 133.922 376.775 133.682C372.381 133.443 368.989 132.59 367.842 132.194",
    stroke: "#D96F62",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.586,
    cy: 117.039,
    rx: 1.69355,
    ry: 4.51613,
    transform: "rotate(4.492 367.586 117.039)",
    fill: "#2D2D2D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.437,
    cy: 117.86,
    rx: 1.69355,
    ry: 4.51613,
    transform: "rotate(4.492 392.437 117.86)",
    fill: "#2D2D2D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 363.898,
    y: 107.592,
    width: 9.40307,
    height: 2.35077,
    rx: 1,
    transform: "rotate(20.0693 363.898 107.592)",
    fill: "#2D2D2D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M358.955 102.843C365.167 91.4897 375.44 86.2822 379.8 85.0977C386.669 87.5795 396.546 95.3239 399.945 116.334C402.665 133.141 393.287 144.095 388.258 147.064C388.258 147.064 410.838 141.145 406.856 110.185C402.879 79.2725 386.864 71.0189 364.227 73.2442C341.59 75.4695 328.388 104.914 328.76 124.977C329.131 145.039 352.942 141.186 356.33 139.919C359.041 138.906 358.091 137.479 357.278 136.892C349.028 130.321 351.19 117.036 358.955 102.843Z",
    fill: "#242424"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 205.471,
    width: 36.5305,
    height: 110.223,
    rx: 18.2652,
    transform: "rotate(-21.6381 268 205.471)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.031,
    cy: 153.73,
    r: 37.2159,
    fill: "#F0AAA2"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.824,
    cy: 158.533,
    rx: 1.80077,
    ry: 4.80205,
    fill: "#2D2D2D"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.235,
    cy: 158.533,
    rx: 1.80077,
    ry: 4.80205,
    fill: "#2D2D2D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M173.929 214.996C172.695 205.426 180.148 196.949 189.797 196.949H291.465C301.114 196.949 308.567 205.426 307.333 214.996L298.765 281.438C297.736 289.417 290.942 295.391 282.896 295.391H198.366C190.32 295.391 183.526 289.417 182.497 281.438L173.929 214.996Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M223.224 186.145H255.637L253.236 208.954H225.625L223.224 186.145Z",
    fill: "#F0AAA2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M258.205 214.523L236.429 209.851L255.037 192.746L258.205 214.523Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M220.523 214.523L242.299 209.851L223.691 192.746L220.523 214.523Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M246.033 261.263L241.746 210.584H236.858L232.828 261.263L239.945 268.209L246.033 261.263Z",
    fill: "#2D6AF6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 9.7756,
    height: 8.74659,
    rx: 2,
    transform: "matrix(-1 0 0 1 244.318 204.152)",
    fill: "#2D6AF6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 228.162,
    width: 146.463,
    height: 88.8379,
    rx: 10,
    fill: "#464646"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.631,
    cy: 273.182,
    r: 5.40231,
    fill: "#2D2D2D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.247,
    cy: 158.533,
    r: 8.40359,
    fill: "#F0AAA2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 231.627,
    y: 175.887,
    width: 12.7658,
    height: 2.40103,
    rx: 1,
    transform: "rotate(-18.963 231.627 175.887)",
    fill: "#D96F62"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 219.073,
    y: 147.938,
    width: 9.6041,
    height: 2.40103,
    rx: 1,
    transform: "rotate(16.1106 219.073 147.938)",
    fill: "#2D2D2D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.628 119.316L227.425 129.72C232.063 128.726 235.544 132.017 239.683 135.929C243.044 139.106 246.838 142.692 252.036 144.726C264.794 149.719 268.667 155.224 271.234 158.873C271.445 159.173 271.647 159.46 271.844 159.733C270.644 151.329 277.247 150.129 277.247 150.129C278.445 135.142 264.677 112.252 238.333 114.106C209.33 113.846 201.621 143.007 202.815 157.332C209.417 132.121 218.422 130.32 226.225 129.72L234.628 119.316Z",
    fill: "#2D2D2D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146.5 150.5L149 131.5L174.5 118.5L181 136.5C176.6 152.9 153.5 152.5 146.5 150.5Z",
    fill: "#EEEEEE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 195C141.1 183.4 139.5 158.5 140.5 144L147 147L175 137.5C173.833 140.833 169.8 151.1 163 165.5C156.2 179.9 147.167 191.167 143.5 195Z",
    fill: "#EEEEEE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M145 132L143 125.5L140.5 146L147 148L145 132Z",
    fill: "#EEEEEE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M142.966 195.413C152.248 179.967 169.484 142.807 176.942 126.157C178.575 126.211 179.936 127.426 180.413 128.027C183.956 132.303 190.96 141.088 190.635 142.013C190.309 142.938 189.141 143.653 188.597 143.895C186.557 144.477 182.316 146.104 181.665 147.955C180.853 150.267 184.733 152.93 184.532 155.458C184.332 157.986 183.313 158.927 171.09 172.169C161.311 182.763 148.266 192.079 142.966 195.413Z",
    fill: "#4C4C4C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M145 192C138 173 140.803 140.414 142.448 128.576C136.909 130.016 130.494 134.728 129.617 138.001C128.916 140.62 130.551 144.488 131.456 146.095C130.242 146.354 127.744 147.556 127.47 150.289C127.127 153.705 128.695 167.075 131.456 176C133.665 183.14 139.218 197.75 143 205C141.916 200.5 142.448 197 145 192Z",
    fill: "#4C4C4C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 195C141.1 183.4 139.5 158.5 140.5 144L147 147L175 137.5C173.833 140.833 169.8 151.1 163 165.5C156.2 179.9 147.167 191.167 143.5 195Z",
    fill: "#EEEEEE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M142.966 195.413C152.248 179.967 169.484 142.807 176.942 126.157C178.575 126.211 179.936 127.426 180.413 128.027C183.956 132.303 190.96 141.088 190.635 142.013C190.309 142.938 189.141 143.653 188.597 143.895C186.557 144.477 182.316 146.104 181.665 147.955C180.853 150.267 184.733 152.93 184.532 155.458C184.332 157.986 183.313 158.927 171.09 172.169C161.311 182.763 148.266 192.079 142.966 195.413Z",
    fill: "#4C4C4C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M145 192C138 173 140.803 140.414 142.448 128.576C136.909 130.016 130.494 134.728 129.617 138.001C128.916 140.62 130.551 144.488 131.456 146.095C130.242 146.354 127.744 147.556 127.47 150.289C127.127 153.705 128.695 167.075 131.456 176C133.665 183.14 139.218 197.75 143 205C141.916 200.5 142.448 197 145 192Z",
    fill: "#4C4C4C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0068 97.1783L79.8012 85.9768C73.3054 98.3384 59.5494 124.413 56.4922 129.819C52.6707 136.576 37 159.252 53 169C65.5418 176.642 75.0757 167.202 77.4228 160.227L99.0068 97.1783Z",
    fill: "#606060"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIntroduction4);
export default __webpack_public_path__ + "static/media/ImgIntroduction4.6fcf860cc3db96e7460d3121477830c1.svg";
export { ForwardRef as ReactComponent };